export default function getDistributorWebsiteUrl(distributor) {
  const domain = distributor?.whiteLabel?.domain;
  if (!domain) return null;
  const protocol = domain.includes('localhost') ? 'http' : 'https';
  return `${protocol}://${domain}`;
}
